/*
akhila 11/09/2022 3225733165 added assigned tab.
akhila 11/10/2022 3225733165 fixed workqueue pagination api  issue.
Saikrishna 11/14/2022 3225733165 Fixed WQ string adding at start of work queue name
Sai Maheshwar 11/16/2022 3225733165 Removed WQ string from start of work queue name
Dilip 12/05/2022 3225733165 removed unnecessary console.log statements
manikanta 01/05/2023 3225733165 Fixed createdDate column
Lalitha 01/09/2023 3225733165 passed value in orderBy and orderDirection
dilip 01/26/2023 3225733165 Add lock account check functionality
Akhila 03/06/2023 3225733165 Added search Functionality in table
Dilip 03/08/2023 3225733165 Added delete Functionality in table
Sohel 03/08/2023 3225733165 Access Modification
Prakash 04/07/2023 3225733165 fixed icon issue.
Akhila 05/17/2023 3225733165 session storage implemened
Ravi 05/31/2023 3225733165 changed delete popup message
*/
import { useHistory } from 'react-router';
import { useUpdateEffect } from 'react-use';
import { useSelector, useDispatch } from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import { httpPaginationPost } from './../../../util/Rest';
import { TablePagination, Tooltip } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useEffect, useState, createRef } from 'react';
import { resetData } from '../../../redux/reducers/WorkQueueList';
import GuiTable from '../../../components/FormComponents/GuiTable';
import { SPLIT_SCREEN } from '../../../constants/WorkQueueConstants';
import { WarningSnackbar } from '../../../components/CustomSnackBar';
import { setShowDashboardWorkQueue } from '../../../redux/reducers/role';
import { getNextAccountData } from '../../../redux/reducers/WorkQueueList';
import { tablePageRows, defaultRows } from '../../../constants/ReusableTablePagination';
import { changeWorkQueueSession, fetchWarning } from '../../../redux/reducers/WorkQueueList';
import {
  getAccessMethodRunList,
  postFieldCode,
} from './../../../redux/reducers/BRE/AddReportMaster';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    backgroundColor: '#38FA8A',
    padding: '3px 10px',
    borderRadius: 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      padding: '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
}));

const Assigned = ({ value, searchData, submit, setSubmit }) => {
  const tableRef = createRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const [status, setStatus] = useState(false);
  const [isWorkQueueClick, setIsWorkQueueClick] = useState(false);
  const { isLoading, nextAccountData, warningMsg } = useSelector(
    ({ workQueueList }) => workQueueList,
  );

  const user = JSON.parse(sessionStorage.getItem('userDetails'));

  const showDashboardOptions = [
    { key: 'N', value: 'No' },
    { key: 'showSplitScreen', value: 'Show Split Screen' },
    { key: 'dontShowSplitScreen', value: "Don't Show Split Screen" },
  ];

  const getShowDashboardValue = (val) => {
    const data = showDashboardOptions.filter((item) => item.key === val)?.[0];
    return data?.value ? data?.value : 'No';
  };

  const searchSeassionAssign = JSON.parse(sessionStorage.getItem('assigned'));

  const runWorkQueue = (rowData) => {
    rowData?.accessMethod &&
      rowData?.action &&
      dispatch(
        postFieldCode({
          fieldCode: rowData?.accessMethod,
          options: rowData?.action,
        }),
      );
    dispatch(getAccessMethodRunList());
  };

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);

  useEffect(() => {
    if (isWorkQueueClick) {
      if (nextAccountData?.nextAccountNumber) {
        const { workQueueNextAccount, updateSession } = changeWorkQueueSession();
        const { workQueueRowData } = workQueueNextAccount;
        const payload = {
          orderBy: '',
          orderDirection: '',
          workQueueId: workQueueRowData?.workqueueId,
        };
        updateSession({
          ...workQueueNextAccount,
          [workQueueRowData.showDashboard]: payload,
          payload: {
            ...payload,
            page: 1,
            limit: 15,
          },
        });
        history.push({
          pathname: `/account-summary`,
          state: {
            accountNumber: nextAccountData?.nextAccountNumber,
          },
        });
      }
      if (nextAccountData?.nextAccountNumber === 0) {
        sessionStorage.removeItem('workQueueNextAccount');
        dispatch(
          fetchWarning(`No accounts in the Work Queue Name: ${nextAccountData?.workQueueName}`),
        );
      }
      setIsWorkQueueClick(false);
    }
  }, [nextAccountData]);

  useEffect(() => {
    if (warningMsg) {
      setTimeout(() => {
        dispatch(resetData());
      }, 3000);
    }
  }, [warningMsg]);

  if (searchSeassionAssign && !submit) {
    searchData = searchSeassionAssign;
  }

  const columns = [
    {
      title: 'Work Queue Name',
      field: 'workqueueName',
      render: (rowData) => {
        return rowData?.workqueueName ? (
          <div
            style={{
              color: '#5351fb',
              fontWeight: 400,
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: '14px',
            }}
            onClick={() => {
              // TODO: This is supposed to run the work queue
              if (
                rowData?.showDashboard &&
                SPLIT_SCREEN.DONT_SHOW_SPLIT_SCREEN === rowData?.showDashboard
              ) {
                history.push({
                  pathname: `/work-queue-list`,
                  state: {
                    workQueueRowData: rowData,
                  },
                });
              }

              // TODO: Is this what runs the queue?
              if (['N', SPLIT_SCREEN.SHOW_SPLIT_SCREEN].includes(rowData?.showDashboard)) {
                setIsWorkQueueClick(true);

                runWorkQueue(rowData);

                dispatch(setShowDashboardWorkQueue(rowData?.showDashboard));

                dispatch(
                  getNextAccountData({
                    accountNumber: 0,
                    orderBy: '',
                    orderDirection: '',
                    workQueueId: rowData?.workqueueId,
                  }),
                );
                // Updates session so the next queue can run.
                // TODO: is there a somehting else that should happend here?
                const { updateSession } = changeWorkQueueSession();
                updateSession({
                  workQueueRowData: rowData,
                });
              }
            }}
          >
            {rowData?.workqueueName}
          </div>
        ) : (
          <div className={` ${classes.disabledWorkQueue}`}>{rowData?.workqueueName}</div>
        );
      },
    },
    {
      title: 'Work Queue Description',
      field: 'workqueueDescription',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.workqueueDescription} interactive>
            <span className="text-wraper">{rowData?.workqueueDescription}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Show Work Queue List',
      field: 'showDashboard',
      render: (rowData) => (
        <>
          <div>{rowData?.showDashboard ? getShowDashboardValue(rowData?.showDashboard) : 'No'}</div>
        </>
      ),
    },
  ];

  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  return (
    <div>
      <div className={classes.root}>
        <div className="global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `workqueuesetup/getall/workqueue/generatedBy`;
                const passValues = {
                  accessRole: user.role ? user.role : '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  limit: query.pageSize ? query.pageSize : null,
                  page:
                    arrayLast && query?.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                  workQueueName: searchData?.workQueueName ? searchData?.workQueueName : '',
                  workQueueDescription: searchData?.workQueueDescription
                    ? searchData?.workQueueDescription
                    : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, passValues)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        setArrayLast(data.length === 1);
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              toolbar: false,
              pageSizeOptions: tablePageRows,
              pageSize: rows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: { 'aria-label': 'Rows per screen' },
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
          />
        </div>
      </div>
      {isLoading && <PageLoader />}
      {warningMsg && <WarningSnackbar errorMsg={warningMsg} />}
    </div>
  );
};

export default Assigned;
